export enum TableCellColor {
    green = "green",
    red = "red",
    yellow = "yellow",
    blue = "blue",
    gray = "gray",
}